export default function () {
  const $backToTopFixed = $('.back-to-top-fixed');
  let lastScrollPosition = 0;

  if ($backToTopFixed.length) {
    $(window).scroll(toggleButton);
    $backToTopFixed.click(function () {
      $('html, body').animate({ scrollTop: 0 }, 500);
      return false;
    });
  }

  function toggleButton() {
    if ($(window).scrollTop() > $(window).innerHeight() && lastScrollPosition > $(window).scrollTop()) {
      $backToTopFixed.addClass('back-to-top-fixed--visible');
    } else {
      $backToTopFixed.removeClass('back-to-top-fixed--visible');
    }
    lastScrollPosition = $(window).scrollTop();
  }
}
